import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ElementRef,
  Renderer2,
} from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import { Answers } from 'src/app/common-class/answers';
import { Group } from 'src/app/common-class/pages';
import { SurveyMessages } from 'src/app/common-class/survey-messages';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { PreviewData } from 'src/app/common-class/survey';
declare var $: any;
@Component({
  selector: 'app-drop-down',
  templateUrl: './drop-down.component.html',
  styleUrls: ['./drop-down.component.css'],
})
export class DropDownComponent implements OnInit, OnChanges {
  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() isDisplaySubQno: boolean;
  @Input() isMDD: boolean;
  @Input() isOtherControl: boolean;
  @Input() DropDown: string;
  @Input() isDemographics: boolean;
  @Input() isMobile: boolean;
  @Input() isGrid: boolean;
  @Input() isNonSearchable: boolean;
  @Input() dropDownlength: number;
  @Input() isNewParticipationButton: boolean;
  @Input() isStandAlone: boolean;
  @Input() group: Group;
  @Input() isAnySubQMandatory: boolean;
  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  questions: Questions;
  answer: Answers;
  questionsQDL: Questions;
  answerImagesLength: number;
  isFormSubmit: boolean = false;
  isFormSubmitSub: any;
  selectedQDLValue: number;
  isPreview: boolean;
  dropDownCount: number;
  isAriaRequired: boolean;
  checkDrillDown: number = 0;
  prevValue: any;
  isNewParticipation: boolean;
  surveyFormat: number;
  newParticipationBtnText: string;
  showNewParticipationButton: boolean;
  isAnsChange: boolean = false;
  isIEOrEdge: boolean = false;
  isOtherQuestion: boolean = false;
  resetPageSub: any;
  MDDdropDownCount: number;
  Nomatchfound: string;
  surveyMessages: SurveyMessages;
  preview: PreviewData;
  isEditPostPop: boolean = false;
  
  setPreviewData(preview: PreviewData) {
    return (this.preview = preview);
  }

  ngOnChanges(changes: SimpleChanges) {
    let curVal;
    let preVal;
    let change = changes['JsonData'];

    if (change) {
      curVal = JSON.stringify(change.currentValue);
      preVal = JSON.stringify(change.previousValue);
    }

    if (curVal != preVal && preVal != undefined) {
      this.questions = JSON.parse(this.JsonData);
    }
  }
  constructor(
    private service: ParticipationDataService,
    private el: ElementRef,
    private renderer: Renderer2,
  ) { }

  ngOnInit() {
    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);

      this.surveyMessages = this.service.getSurveyMessages();
      let updateItem = this.questions?.Answers.find((e) => e.hasImage && e.AnswerImages.length == 2);
      this.isEditPostPop = this.service.getisEditPostPop();
      if (this.questions?.Answers.filter((e) => e.isOther).length > 0) {
        this.isOtherQuestion = true;
      }

      if (this.questions?.population_type == 3) {
        this.isAnsChange = true;
      }

      if (updateItem != null && updateItem != undefined) {
        this.answerImagesLength = 2;

        if (this.questions.population_type == 3) {
          if (this.questions.selectAnsValue != updateItem.value_id) {
            this.answerImagesLength = 0;
          }
        }
      } else {
        updateItem = this.questions?.Answers.find((e) => e.hasImage && e.AnswerImages.length == 1);

        if (updateItem != null && updateItem != undefined) {
          this.answerImagesLength = 1;

          if (this.questions?.population_type == 3) {
            if (this.questions.selectAnsValue != updateItem.value_id) {
              this.answerImagesLength = 0;
            }
          }
        }
      }

      if (
        this.questions?.answer_style == 1 &&
        this.questions?.RotateIndex == 0 &&
        this.questions?.Answers != null
      ) {
        this.RandomAnswerHandling();
      }

      if (this.questions?.selectAnsValue >= 0) {
        let updateItem = this.questions.Answers.find(
          (e) => e.value_id == this.questions.selectAnsValue,
        );
        if (updateItem == null && updateItem == undefined) {
          this.questions.selectAnsValue = -1;
        } else if (updateItem.isQuotaDisable) {
          this.questions.selectAnsValue = -1;
        }
      } else {
        if (this.questions) {
          this.questions.selectAnsValue = -1;
        }
        
      }
      this.isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    }
    if (this.isGrid) {
      this.dropDownCount = this.service.getMDDdropDownCount();
    } else {
      this.dropDownCount = this.service.getdropDownCount();
    }
    this.MDDdropDownCount = this.service.getMDDdropDownCount();
    this.isFormSubmitSub = this.service.emitFormSubmitEvent.subscribe((data) => {
      this.isFormSubmit = data;
    });

    this.isPreview = this.service.GroupType?.toUpperCase() == 'PREVIEW';

    this.isAriaRequired =
      (this.questions?.mandatory && (this.isMandatoryUpfront || this.questions?.isMandatoryStar)) ||
      (this.questions?.mandatory && this.isFormSubmit && this.questions?.isMandatoryInvalid);

    this.isNewParticipation = this.service.isNewParticipation;
    this.surveyFormat = this.service.surveyFormat;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
    this.showNewParticipationButton =
      this.isNewParticipationButton &&
      (!this.service.isAutoScroll || this.questions.population_type == 3);
    this.Nomatchfound = this.service.getSurveyMessages()?.Participation_Nomatchfound;
  }

  ngAfterViewInit() {
    const messageElements = document.querySelectorAll(`.drill-down-list-itemMessage_${this.questions.UniqueNumber}`);
    messageElements.forEach((el) => {
      (el as HTMLElement).style.display = 'none';
    });

    setTimeout(() => {
      const element = this.el.nativeElement.querySelector('input.drill-down-input');
      if (element) {
        if ((element as HTMLInputElement).value) {
          this.renderer.addClass(element, 'no-search-icon');
        } else {
          this.renderer.removeClass(element, 'no-search-icon');
        }
      }
    }, 1);

   setTimeout(() => {
    const element1 = this.el.nativeElement.querySelector('.custom-select-wrapper');
    const messageElements = document.querySelectorAll(`.drill-down-list-itemMessage_${this.questions.UniqueNumber}`);
    
    if (element1 && messageElements.length) {
      messageElements.forEach((el) => {
        (el as HTMLElement).style.width = `${element1.clientWidth}px`;
      });
    }
  }, 1);

    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if (data) {
        this.isAnsChange = false;
        const element = this.el.nativeElement.querySelector('input.drill-down-input');
        this.renderer.removeClass(element, 'no-search-icon');
      }
    });
  }

  ngOnDestroy() {
    this.isFormSubmitSub.unsubscribe();
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  RandomAnswerHandling() {
    let currentIndex = this.questions.Answers.length,
      temporaryValue,
      randomIndex;
    let updateItem = this.questions.Answers.find((e) => e.isOther);
    if (updateItem != undefined && updateItem != null) {
      currentIndex -= 1;
    }

    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = this.questions.Answers[currentIndex];
      this.questions.Answers[currentIndex] = this.questions.Answers[randomIndex];
      this.questions.Answers[randomIndex] = temporaryValue;
    }
  }

  GetRBClass(DispAnsCol: number) {
    switch (DispAnsCol) {
      case 1:
        return 'radio-hrb_1';
      case 2:
        return 'radio-hrb_2';
      case 3:
        return 'radio-hrb_3';
      case 4:
        return 'radio-hrb_4';
      case 5:
        return 'radio-hrb_5';
      default:
        return 'radio-hrb';
    }
  }

  GetMandatoryState(): boolean {
    if (this.questions != null) {
      return this.questions.mandatory;
    }
  }

  SelectedValue(event: any, isSearchableDD: boolean = false, curVal: number = -1) {
    let value = event.target.value;
    if (isSearchableDD) {
      value = curVal.toString();
    }
    if (value === '-1') {
      if (this.questions.Answers.find((e) => e.selectdId == 1) != undefined) {
        this.questions.Answers.find((e) => e.selectdId == 1).ControlAns = null;
        this.questions.Answers.find((e) => e.selectdId == 1).selectdId = 0;
      }
      this.questions.isOtherAnswer = false;
      this.questions.selectAnsValue = -1;
      this.questions.AnswerID = 0;
      this.questions.pageto = 0;
      this.questions.AnswerText = null;
    } else {
      for (let i = 0; i < this.questions.Answers.length; i++) {
        if (value == this.questions.Answers[i].value_id && !this.questions.Answers[i].isADLHide) {
          event.selectdId = 1;
          this.questions.Answers[i].selectdId = 1;
          this.questions.Answers[i].ControlAns = this.questions.Answers[i].value_text;
          this.questions.AnswerID = this.questions.Answers[i].ms_id;
          this.questions.selectAnsValue = this.questions.Answers[i].value_id;
          this.questions.AnswerText = this.questions.Answers[i].value_text;
          this.questions.pageto = this.questions.Answers[i].pageto;
          this.questions.otherAnswer = null;

          if (this.questions.isSoftRequired) {
            this.questions.isSoftRequiredHandle = true;
          }

          if (this.questions.Answers[i].isOther) {
            this.questions.isOtherAnswer = true;
            let id = this.questions.UniqueNumber + '_txt_other';
            let control = document.getElementById(id);

            setTimeout(function () {
              control.focus();
            }, 0);
          } else {
            this.questions.isOtherAnswer = false;
          }
        } else {
          this.questions.Answers[i].ControlAns = null;
          this.questions.Answers[i].selectdId = 0;
        }
      }
    }
    this.UpdateQuestionsData(this.questions);;
  }

  findIndexToUpdate(answer) {
    return answer === this;
  }

  GetQuestionsString(question: Questions, index: number): string {
    return JSON.stringify(question);
  }

  UpdateQuestionsData(question: Questions) {
    if (this.questions.isOtherAnswer || this.showNewParticipationButton) {
      this.isAnsChange = true;
    }
    this.ChangeAnswersData.emit(question);
  }

  getHiddenAnswer(answers: Answers) {
    return !answers.isHide;
  }

  setDrillDownValue(event: any, question: Questions, self, curVal: number) {
    self.SelectedValue(event, true, curVal);
    let element = this.el.nativeElement.querySelector('input.drill-down-input');
    if (element.value) {
      this.renderer.addClass(element, 'no-search-icon');
    } else {
      this.renderer.removeClass(element, 'no-search-icon');
    }
  }

  showDDList(event) {
    const target = event.target as HTMLElement;
    const drillDownSearch = target.closest('.drill-down-search');
    const drillDownInput = drillDownSearch?.querySelector('.drill-down-input') as HTMLElement;
    
    if (drillDownSearch?.classList.contains('showDrillList')) {
      drillDownSearch.classList.remove('showDrillList');
      drillDownInput?.setAttribute('aria-expanded', 'false');
    } else {
      document.querySelectorAll('.drill-down-search').forEach(el => {
        el.classList.remove('showDrillList');
      });
      drillDownSearch?.classList.add('showDrillList');
      drillDownInput?.setAttribute('aria-expanded', 'true');
      drillDownInput?.focus();
      
      const listItems = drillDownSearch?.querySelectorAll('.drill-down-list-item');
      listItems?.forEach(item => {
        (item as HTMLElement).style.display = 'block';
      });
    }
  }

  selectDDListItem(event, question: Questions) {
    const target = event.target as HTMLElement;
    const drillDownSearch = target.closest('.drill-down-search');
    const drillDownInput = drillDownSearch?.querySelector('.drill-down-input') as HTMLInputElement;
    const select = drillDownSearch?.querySelector('select') as HTMLSelectElement;
    
    if (drillDownInput) {
      drillDownInput.value = '';
    }
    
    const listItems = drillDownSearch?.querySelectorAll('.drill-down-list-item');
    listItems?.forEach(item => {
      const ogValue = item.getAttribute('ogListValue');
      if (ogValue) {
        item.innerHTML = ogValue;
        (item as HTMLElement).style.display = 'block';
        item.innerHTML = this.highlight(item.innerHTML, '');
      }
    });

    const itemText = target.getAttribute('ogListValue');
    const itemValue = target.getAttribute('list-value');
    
    if (select && itemValue) {
      select.value = itemValue;
    }
    
    if (drillDownInput && itemText) {
      drillDownInput.value = itemText;
    }
    
    drillDownSearch?.classList.remove('showDrillList');
    drillDownInput?.setAttribute('aria-expanded', 'false');
    
    this.checkDrillDown = 1;
    this.setDrillDownValue(event, question, this, itemValue ? parseInt(itemValue) : 0);
    this.nextQuestion(event.target);
  }

  setDDListItem(event, question: Questions) {
    setTimeout(() => {
      if (this.checkDrillDown === 0 && this.checkDrillDown !== undefined) {
        const target = event.target as HTMLInputElement;
        const drillDownSearch = target.closest('.drill-down-search');
        const select = drillDownSearch?.querySelector('select') as HTMLSelectElement;
        const ddSearchValue = target.value.toLowerCase();
        
        if (ddSearchValue !== '') {
          const listItems = Array.from(drillDownSearch?.querySelectorAll('.drill-down-list-item') || []);
          let foundMatch = false;
          
          for (const item of listItems) {
            const ogValue = item.getAttribute('ogListValue');
            if (ogValue) {
              item.innerHTML = ogValue;
              if (ddSearchValue === item.textContent?.toLowerCase()) {
                target.value = ogValue;
                target.setAttribute('aria-expanded', 'false');
                const itemValue = item.getAttribute('list-value');
                if (select && itemValue) {
                  select.value = itemValue;
                }
                this.setDrillDownValue(event, question, this, itemValue ? parseInt(itemValue) : 0);
                foundMatch = true;
                break;
              }
            }
          }
          
          if (!foundMatch) {
            target.value = '';
            if (select) {
              select.value = '0';
            }
            this.questions.AnswerText = null;
            this.setDrillDownValue(event, question, this, -1);
          }
        } else {
          this.questions.AnswerText = null;
          this.setDrillDownValue(event, question, this, -1);
        }
      }
    }, 0);
    
    (event.target as HTMLElement).setAttribute('aria-expanded', 'false');
    
      setTimeout(() => {
        const messageElements = document.querySelectorAll(`.drill-down-list-itemMessage_${this.questions.UniqueNumber}`);
        messageElements.forEach((el) => {
          (el as HTMLElement).style.display = 'none';
        });
      }, 1);
  }

  filterDDSearch(event) {
    const target = event.target as HTMLInputElement;
    const drillDownSearch = target.closest('.drill-down-search');
    const select = drillDownSearch?.querySelector('select') as HTMLSelectElement;
    const keyCode = event.keyCode || event.which;
    
    if (keyCode === 13 || keyCode === undefined) {
      event.preventDefault();
      target.blur();
      setTimeout(() => {
        drillDownSearch?.classList.remove('showDrillList');
        target.setAttribute('aria-expanded', 'false');
      }, 100);
    }
    
    setTimeout(() => {
      if (keyCode !== 9) {
        drillDownSearch?.classList.add('showDrillList');
        target.setAttribute('aria-expanded', 'true');
        
        if (keyCode === 40) {
          event.preventDefault();
          const currentActive = drillDownSearch?.querySelector('.currentActiveDDITem');
          const visibleItems = Array.from(drillDownSearch?.querySelectorAll('.drill-down-list-item') || [])
            .filter(item => (item as HTMLElement).style.display !== 'none');
            
          if (!select || select.value <= '0' || 
              select.value === visibleItems[visibleItems.length - 1]?.getAttribute('list-value')) {
            if (select && visibleItems[0]) {
              select.value = visibleItems[0].getAttribute('list-value') || '0';
              target.value = select.options[select.selectedIndex].text;
            }
            currentActive?.classList.remove('currentActiveDDITem');
            visibleItems[0]?.classList.add('currentActiveDDITem');
          } else {
            const currentIndex = visibleItems.indexOf(currentActive as Element);
            const nextElement = visibleItems[currentIndex + 1];
            
            if (nextElement) {
              if (select) {
                select.value = nextElement.getAttribute('list-value') || '0';
                target.value = select.options[select.selectedIndex].text;
              }
              currentActive?.classList.remove('currentActiveDDITem');
              nextElement.classList.add('currentActiveDDITem');
            }
          }
          
          // Scroll handling
          const activeElement = drillDownSearch?.querySelector('.currentActiveDDITem');
          const listContainer = drillDownSearch?.querySelector('.drill-down-list');
          
          if (activeElement && listContainer) {
            const elementRect = activeElement.getBoundingClientRect();
            const containerRect = listContainer.getBoundingClientRect();
            
            if (elementRect.bottom > containerRect.bottom) {
              listContainer.scrollTop += elementRect.bottom - containerRect.bottom;
            } else if (elementRect.top < containerRect.top) {
              listContainer.scrollTop -= containerRect.top - elementRect.top;
            }
          }
        } else if (keyCode === 38) {
          // Similar logic for up arrow key
          event.preventDefault();
          const currentActive = drillDownSearch?.querySelector('.currentActiveDDITem');
          const visibleItems = Array.from(drillDownSearch?.querySelectorAll('.drill-down-list-item') || [])
            .filter(item => (item as HTMLElement).style.display !== 'none');
            
          if (!select || select.value <= '0' || 
              select.value === visibleItems[0]?.getAttribute('list-value')) {
            if (select && visibleItems[visibleItems.length - 1]) {
              select.value = visibleItems[visibleItems.length - 1].getAttribute('list-value') || '0';
              target.value = select.options[select.selectedIndex].text;
            }
            currentActive?.classList.remove('currentActiveDDITem');
            visibleItems[visibleItems.length - 1]?.classList.add('currentActiveDDITem');
          } else {
            const currentIndex = visibleItems.indexOf(currentActive as Element);
            const prevElement = visibleItems[currentIndex - 1];
            
            if (prevElement) {
              if (select) {
                select.value = prevElement.getAttribute('list-value') || '0';
                target.value = select.options[select.selectedIndex].text;
              }
              currentActive?.classList.remove('currentActiveDDITem');
              prevElement.classList.add('currentActiveDDITem');
            }
          }
          
          // Scroll handling
          const activeElement = drillDownSearch?.querySelector('.currentActiveDDITem');
          const listContainer = drillDownSearch?.querySelector('.drill-down-list');
          
          if (activeElement && listContainer) {
            const elementRect = activeElement.getBoundingClientRect();
            const containerRect = listContainer.getBoundingClientRect();
            
            if (elementRect.bottom > containerRect.bottom) {
              listContainer.scrollTop += elementRect.bottom - containerRect.bottom;
            } else if (elementRect.top < containerRect.top) {
              listContainer.scrollTop -= containerRect.top - elementRect.top;
            }
          }
        } else {
          drillDownSearch?.querySelector('.currentActiveDDITem')?.classList.remove('currentActiveDDITem');
          if (select) {
            select.value = '-1';
          }
          
          const ddSearchValue = target.value.toLowerCase();
          if (ddSearchValue !== '') {
            let isShowMessage = false;
            const listItems = drillDownSearch?.querySelectorAll('.drill-down-list-item');
            
            listItems?.forEach(item => {
              const ogValue = item.getAttribute('ogListValue');
              if (ogValue) {
                item.innerHTML = ogValue;
                if (item.textContent?.toLowerCase().includes(ddSearchValue)) {
                  (item as HTMLElement).style.display = 'block';
                  item.innerHTML = this.highlight(item.innerHTML, ddSearchValue);
                  isShowMessage = true;
                } else {
                  (item as HTMLElement).style.display = 'none';
                }
              }
            });
            
           const messageElements = document.querySelectorAll(`.drill-down-list-itemMessage_${this.questions.UniqueNumber}`);
            messageElements.forEach((el) => {
              (el as HTMLElement).style.display = isShowMessage ? 'none' : 'block';
            });

            
            const visibleItems = Array.from(drillDownSearch?.querySelectorAll('.drill-down-list-item') || [])
              .filter(item => (item as HTMLElement).style.display !== 'none');
              
            if (visibleItems.length === 0) {
              drillDownSearch?.classList.remove('showDrillList');
              target.setAttribute('aria-expanded', 'false');
            } else {
              drillDownSearch?.classList.add('showDrillList');
              target.setAttribute('aria-expanded', 'true');
            }
          } else {
          
            const messageElements = document.querySelectorAll(`.drill-down-list-itemMessage_${this.questions.UniqueNumber}`);
            messageElements.forEach((el) => {
              (el as HTMLElement).style.display = 'none';
            });
            
            const listItems = drillDownSearch?.querySelectorAll('.drill-down-list-item');
            listItems?.forEach(item => {
              const ogValue = item.getAttribute('ogListValue');
              if (ogValue) {
                item.innerHTML = ogValue;
                (item as HTMLElement).style.display = 'block';
              }
            });
          }
          
          if (target.value !== this.prevValue) {
            this.checkDrillDown = 0;
          } else {
            this.checkDrillDown = 1;
          }
        }
      } else {
        drillDownSearch?.classList.remove('showDrillList');
        target.setAttribute('aria-expanded', 'false');
      }
    }, 1);
  }

  setPrevValue(event) {
    this.prevValue = event.target.value;
  }

  highlight(s, search) {
    return s.replace(
      new RegExp(search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gi'),
      '<b>$&</b>',
    );
  }

nextQuestion(event) {
  
    if (this.isNewParticipation && (this.surveyFormat == 1 || this.surveyFormat == 2) && this.service.isAutoScroll && !(!this.service.isMobile&&this.questions.qtype == "RW"&&this.questions.qsubtype==2) && !(this.isDemographics && this.dropDownlength != 1)) {
      if (this.questions.selectAnsValue != 0) {
  
        if (this.isStandAlone) {
          let scrollTargetElement = $('#bodyScroll');
          const checkIfPrevirew = this.service.preview && this.service.preview.viewport;
          var nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').length;
          if(this.questions.isMatrixQuestion){
            var MatrixelemPosition;
            MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id)
            var MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont')
          }
          if(this.questions.qtype == "RW" && !this.questions.isMatrixQuestion){
            var MDDelemPosition;
            MDDelemPosition = $(event).closest('.mdd-data_' + this.questions.group_no).nextAll('.mdd-data_' + this.questions.group_no)
          }
          if(this.questions.qtype == "RW" && !this.questions.isMatrixQuestion && MDDelemPosition.length > 0){
            MDDelemPosition = $(event).closest('.mdd-data_' + this.questions.group_no).nextAll('.mdd-data_' + this.questions.group_no).has('.question-data').eq(0).offset().top;
            if(checkIfPrevirew && checkIfPrevirew != ''){
              if(this.service.preview.viewport === "web"){
                MDDelemPosition = MDDelemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop() - $('.toolbar').innerHeight();
              }
              else {
                scrollTargetElement = $('.app-participation');
                MDDelemPosition = MDDelemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
              }
            } else {
              MDDelemPosition = MDDelemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
            }
            
            
            scrollTargetElement.animate({
              scrollTop: (MDDelemPosition - $(window).height() / 3)
            }, 400);
          }else if (this.questions.isMatrixQuestion && MatrixelemPosition.length > 0) {
            MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id).has('.question-data').eq(0).offset().top;
            if(checkIfPrevirew && checkIfPrevirew != ''){
              if(this.service.preview.viewport === "web"){
                MatrixelemPosition = MatrixelemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop() - $('.toolbar').innerHeight();
              }
              else {
                scrollTargetElement = $('.app-participation');
                MatrixelemPosition = MatrixelemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
              }
            } else {
              MatrixelemPosition = MatrixelemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
            }
            
          
            scrollTargetElement.animate({
              scrollTop: (MatrixelemPosition - $(window).height() / 3)
            }, 400);
          } else if (this.questions.isMatrixQuestion && MatrixelemPosition1.length > 0) {
            MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont').has('.question-data').eq(0).offset().top;
            
            if(checkIfPrevirew && checkIfPrevirew != ''){
              if(this.service.preview.viewport === "web"){
                MatrixelemPosition1 = MatrixelemPosition1 - scrollTargetElement.offset().top + scrollTargetElement.scrollTop() - $('.toolbar').innerHeight();
              }
              else {
                scrollTargetElement = $('.app-participation');
                MatrixelemPosition1 = MatrixelemPosition1 - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
              }
            } else {
              MatrixelemPosition1 = MatrixelemPosition1 - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
            }
            scrollTargetElement.animate({
              scrollTop: (MatrixelemPosition1 - $(window).height() / 3)
            }, 400);
          } else if (nextbtnLength > 0){
            nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;
            if(checkIfPrevirew && checkIfPrevirew != ''){
              if(this.service.preview.viewport === "web"){
                nextbtnLength = nextbtnLength - scrollTargetElement.offset().top + scrollTargetElement.scrollTop() - $('.toolbar').innerHeight();
              }
              else {
                scrollTargetElement = $('.app-participation');
                nextbtnLength = nextbtnLength - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
              }
            } else {
              nextbtnLength = nextbtnLength - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
            }
            scrollTargetElement.animate({
              scrollTop: (nextbtnLength - $(window).height() / 3)
            }, 400);
          }else{
            if(checkIfPrevirew && checkIfPrevirew != ''){
              if(this.service.preview.viewport === "web"){
                scrollTargetElement = $('#bodyScroll');
              }
              else {
                scrollTargetElement = $('.app-participation');
              }
              } 
              var scrollVal = $('.tblPageFooter').offset().top + scrollTargetElement.scrollTop();
              scrollTargetElement.animate({
              scrollTop: scrollVal
            }, 400);
          }
        } else {
          this.service.gotoNextQuestion(this.questions, event);
        }
        
      } else {
        $(event).closest('.main-ques-cont').find('.ques-response-btn-div').show();
      }
    }
    else if (this.service.surveyFormat == 3 && !this.isDemographics && this.questions.qtype != "RW") {
      var currElem = $('.active-ques');
      var nextElem = currElem.nextAll('.inactive-ques').has('.question-data').eq(0);
      var afterNextElem = currElem.nextAll('.inactive-ques').has('.question-data').eq(1);
      if (nextElem.length > 0) {
        $('.back-arrow').removeClass('disabled');
        this.service.hideQuestion(currElem[0]);
        let isHidden = $(nextElem).find(".question-data").attr("hidden");

        if (isHidden) {
          this.service.showQuestion(afterNextElem[0]);
        } else {
          this.service.showQuestion(nextElem[0]);
        }

        if (afterNextElem.length == 0 && $('.next-button').length == 0) {
          $('.next-arrow').addClass('disabled');
        }
      } else {
        if ($('.next-button').length != 0) {
          $('.next-button').trigger('click');
        }
      }
    }
  }


  gotoNextQuestion(question: Questions, event) {
   
    if (this.isStandAlone) {
      let scrollTargetElement = $('#bodyScroll');
      const checkIfPrevirew = this.service.preview && this.service.preview.viewport;
      var nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').length;
      var MatrixelemPosition;
      MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id)
      //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id)
      var MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont')
      if (MatrixelemPosition.length > 0) {
        MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id).has('.question-data').eq(0).offset().top;
        if(checkIfPrevirew && checkIfPrevirew != ''){
          if(this.service.preview.viewport === "web"){
            MatrixelemPosition = MatrixelemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop() - $('.toolbar').innerHeight();
          }
          else {
            scrollTargetElement = $('.app-participation');
            MatrixelemPosition = MatrixelemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
          }
        } else {
          MatrixelemPosition = MatrixelemPosition - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
        }
        
        scrollTargetElement.animate({
          scrollTop: (MatrixelemPosition - $(window).height() / 3)
        }, 400);
      } else if (MatrixelemPosition1.length > 0) {
       MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont').has('.question-data').eq(0).offset().top;
       if(checkIfPrevirew && checkIfPrevirew != ''){
        if(this.service.preview.viewport === "web"){
          MatrixelemPosition1 = MatrixelemPosition1 - scrollTargetElement.offset().top + scrollTargetElement.scrollTop() - $('.toolbar').innerHeight();
        }
        else {
          scrollTargetElement = $('.app-participation');
          MatrixelemPosition1 = MatrixelemPosition1 - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
        }
      } else {
        MatrixelemPosition1 = MatrixelemPosition1 - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
      }
      
      scrollTargetElement.animate({
          scrollTop: (MatrixelemPosition1 - $(window).height() / 3)
        }, 400);
      } else if (nextbtnLength > 0){
        nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;
        
        if(checkIfPrevirew && checkIfPrevirew != ''){
          if(this.service.preview.viewport === "web"){
            nextbtnLength = nextbtnLength - scrollTargetElement.offset().top + scrollTargetElement.scrollTop() - $('.toolbar').innerHeight();
          }
          else {
            scrollTargetElement = $('.app-participation');
            nextbtnLength = nextbtnLength - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
          }
        } else {
          nextbtnLength = nextbtnLength - scrollTargetElement.offset().top + scrollTargetElement.scrollTop();
        }
        
        scrollTargetElement.animate({
          scrollTop: (nextbtnLength - $(window).height() / 3)
        }, 400);
      }else{

        if(checkIfPrevirew && checkIfPrevirew != ''){
        if(this.service.preview.viewport === "web"){
          scrollTargetElement = $('#bodyScroll');
        }
        else {
          scrollTargetElement = $('.app-participation');
        }
        } 
        var scrollVal = $('.tblPageFooter').offset().top + scrollTargetElement.scrollTop();

        scrollTargetElement.animate({
          scrollTop: scrollVal
        }, 400);
      }
    } else {
      this.service.gotoNextQuestion(this.questions, event);
    }
    //this.service.gotoNextQuestion(question, event);
  }

  closeDDList(event) {
    const target = event.target as HTMLInputElement;
    if (target.value !== '') {
      target.value = '';
    }
    const drillDownSearch = target.closest('.drill-down-search');
    drillDownSearch?.classList.remove('showDrillList');
    target.setAttribute('aria-expanded', 'false');
  }

  gotoNextQuestionKeyboard(question, event) {
    event.preventDefault();
    this.gotoNextQuestion(question, event.target);
  }

  onBlurMethod() {
    if (this.questions.otherAnswer == '') {
      this.questions.otherAnswer = null;
    }
    this.UpdateQuestionsData(this.questions);
  }
}
